// extracted by css-extract-rspack-plugin
export default {"wrapper":"nqbUb","search_opened":"rAqDh","searchOpened":"rAqDh","resultsAnchor":"jZeXP","search":"oHJ6F","title":"W86vH"};